import { validateForUI } from 'common/helpers/jsonValidator';

const availabilitySchema = {
  type: 'object',
  properties: {
    reservationTypeId: { type: 'string' },
    guestCount: { type: 'integer', minimum: 1 },
    reservationDate: { type: 'string', format: 'date' },
    reservationTime: { type: 'string', format: 'iso-time' }
  },
  required: ['guestCount', 'reservationDate', 'reservationTime'],
  additionalProperties: false
};

export const validateSearch = (availability) => {
  const errors = validateForUI(availabilitySchema, availability);
  return errors;
};

export const validateSearchWidget = (availability) => {
  const errors = validateForUI(availabilitySchema, availability);
  return errors;
};
